import React, { useEffect, useState, useRef } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
// import "../PagesStyles/AdminMasters.css";
import style from "./VendorTouncheNew.module.css";
import Customertable from "Components/support/customervendor/customer";
import {
  a104,
  a107,
  a125,
  a128,
  a131,
  a134,
  a149,
  a163,
  a174,
  a179,
  a180,
  a191,
  a95,
  a98,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
import GetApiService from "../../Api/getapiService.jsx";
import Stonetounch from "../../support/customertounchsupport/stones.jsx";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchVendorTouncheList } from "services/Tounches";
import PageLoader from "Components/PageLoader";
import { VendorTouncListColumns } from "utils/helpers";

export default function VendorTounchNewList() {
  const navigate = useNavigate();

  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);
  const [productsData, setProductsData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [designData, setDesignData] = useState([]);
  const [purityData, setPurityData] = useState([]);
  const [skuData, setSkuData] = useState([]);
  const [templateData, setTemplateData] = useState([]);

  const [filteredData, setFilteredData] = useState([]);
  const [fcat, setFcat] = useState("");
  const [fpro, setFpro] = useState("");

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    VendorId: 0,
    CategoryId: 0,
    ProductId: 0,
    ClientCode: "",
    FinePure: false,
    PurityId: 0,
    FinePercentage: 0,
    WastageWt: "0",
    MakingFixedAmt: "0",
    MakingPerGram: "0",
    MakingFixedWastage: "0",
    MakingPercentage: "0",
    StockKeepingUnit: "",
    CompanyId: 0,
    CounterId: 0,
    BranchId: 0,
    EmployeeId: 0,
    OldEntry: false,
    DiamondSizeWeightRateTemplateId: 0,
    Stones: [],
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const [allSelectedTounche, setAllSelectedTounche] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [showSKU, setShowSKU] = useState(true);
  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };
  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };

  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const apiService = new GetApiService(clientCode);

  const {
    data: vendorTounchelist,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["vendorTounche/vendorTouncheList", clientCode],
    queryFn: fetchVendorTouncheList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });

  return (
    <div>
      {isLoading && <PageLoader />}
      <AdminHeading />
      <div style={{ paddingTop: "130px" }}>
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Vendor Tounche"}
          companyName={"Loyalstring"}
          module={"Settings"}
          page={"Vendor Tounche"}
        />
      </div>
      <div style={{ padding: "16px" }}>
        <>
          <div className={style["white-space"]}>
            <div className={style["icon-div"]}>
              <div className={style["search-container"]}>
                <input
                  type="text"
                  value={searchInput}
                  onChange={handleSearchChange}
                  placeholder="Search..."
                  className={style["serach-input"]}
                />
                <button
                  style={{ margin: 0 }}
                  className={style["search-btn"]}
                  onClick={handleSearchSubmit}
                >
                  <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                </button>
              </div>

              <Icon
                style={{
                  fontSize: "28px ",
                  color: "#0077d4",
                  cursor: "pointer",
                }}
                icon="bx:export"
              />

              <button
                // style={{ width: "30%" }}
                className={style["custom-btn"]}
              >
                <Icon style={{ fontSize: "24px " }} icon="ic:outline-print" />
                Print
              </button>
              <button
                //  onClick={handlenew}
                onClick={() => navigate("/vendor_tounche_new")}
                style={{ margin: 0 }}
                className={style["custom-btn"]}
              >
                New
                <Icon icon="mdi:plus" width="24" height="24" />
              </button>
            </div>
          </div>

          <Customertable
            columns={VendorTouncListColumns}
            allCategories={vendorTounchelist?.length ? vendorTounchelist : []}
            handleEditData={(product) =>
              navigate(`/edit_Vendor_tounche_new/${product?.Id}`)
            }
            searchInput={searchInput}
            setSearchInput={setSearchInput}

            // title={"All Customers"}
          />
        </>
      </div>
    </div>
  );
}
